import { PackageEnum } from '@insurance/api/requests'
import { BooleanRadioCardGroup } from '@insurance/components'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const SpecificAdjustments = () => {
  const { t } = useTranslation()
  const {
    claimLastYearProps,
    officialDealerRepairProps,
    insurancePackageProps,
    annualBonusProps
  } = formProps(t)
  const { isEditable } = useCascoInsuranceValues()

  const insurancePackage = Form.useWatch<PackageEnum>(
    insurancePackageProps.name,
    { preserve: true }
  )

  const annualBonus = Form.useWatch(annualBonusProps.name, { preserve: true })

  if (insurancePackage === PackageEnum.MINI) return null

  const disabledClaimLastYear = !!annualBonus

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={12}>
        <Form.Item {...claimLastYearProps}>
          <BooleanRadioCardGroup
            disabled={disabledClaimLastYear || isEditable}
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item {...officialDealerRepairProps}>
          <BooleanRadioCardGroup disabled={isEditable} />
        </Form.Item>
      </Col>
    </Row>
  )
}
